export const SLUG_POST_SUB_QUESTION_ID = "sub-question";
